import { Injectable } from '@angular/core';

import { ClientConfigProductName } from '../client-config/client-config-product-name.model';
import { ClientConfig } from '../client-config/client-config.decorator';
import { ClientConfigService } from '../client-config/client-config.service';

/** @stable */
@ClientConfig({ key: 'vnRememberMe', product: ClientConfigProductName.SF })
@Injectable({
    providedIn: 'root',
    deps: [ClientConfigService],
    useFactory: rememberMeConfigFactory,
})
export class RememberMeConfig {
    isEnabled: boolean;
    apiHost: string;
    skipRetryPaths: string[];
    loginOnDocumentRequest: boolean;
}

export function rememberMeConfigFactory(service: ClientConfigService) {
    return service.get(RememberMeConfig);
}
